import {clearGameMessage, fetchGameMessageSuccess} from "modules/actions/gameMessage";
import {createReducer} from "redux-act";

interface IErrorReducer {
	message?: string;
}

export const gameMessage = createReducer<IErrorReducer>({}, {})
	.on(fetchGameMessageSuccess, (state, payload) => ({
		...state,
		message: payload.text,
	}))
	.on(clearGameMessage, () => ({}));
